import { render, staticRenderFns } from "./PriceLogDialog.vue.vue?vue&type=template&id=32a0930a&scoped=true&"
import script from "./PriceLogDialog.vue.vue?vue&type=script&lang=js&"
export * from "./PriceLogDialog.vue.vue?vue&type=script&lang=js&"
import style0 from "./PriceLogDialog.vue.vue?vue&type=style&index=0&id=32a0930a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32a0930a",
  null
  
)

export default component.exports